export default import.meta.ROLLUP_FILE_URL_OK8e9ZLGxjE9c4QuZLFupA